import { cloneQuery } from '@esentai/core/queries';

export default () => (state, { payload: limit }) => {
  const queryClone = cloneQuery(state);

  queryClone.set('limit', limit);

  return queryClone;
};
